export const CANCELLATION_POLICY_MODES = ['account', 'custom', 'none'] as const;
export type CancellationPolicyMode = (typeof CANCELLATION_POLICY_MODES)[number];

export const CANCELLATION_POLICY_SOURCES = [
  'account',
  'custom',
  'none',
] as const;
export type CancellationPolicySource =
  (typeof CANCELLATION_POLICY_SOURCES)[number];

export const CANCELLATION_POLICY_WINDOW_UNITS = ['hours', 'days'] as const;
export type CancellationPolicyWindowUnit =
  (typeof CANCELLATION_POLICY_WINDOW_UNITS)[number];

export const CANCELLATION_POLICY_STATES = [
  'no_policy',
  'before_cutoff',
  'late_allowed',
  'blocked',
] as const;
export type CancellationPolicyState =
  (typeof CANCELLATION_POLICY_STATES)[number];

export const CANCELLATION_POLICY_RECORD_KINDS = [
  'late_cancel',
  'blocked_cancel',
  'blocked_reschedule',
] as const;
export type CancellationPolicyRecordKind =
  (typeof CANCELLATION_POLICY_RECORD_KINDS)[number];

export const CANCELLATION_POLICY_RECORD_CHANNELS = [
  'link',
  'sms',
  'voice',
  'owner',
] as const;
export type CancellationPolicyRecordChannel =
  (typeof CANCELLATION_POLICY_RECORD_CHANNELS)[number];

export const CANCELLATION_POLICY_WINDOW_LIMITS: Record<
  CancellationPolicyWindowUnit,
  { min: number; max: number }
> = {
  hours: { min: 1, max: 720 },
  days: { min: 1, max: 30 },
};

export const CANCELLATION_POLICY_TEXT_MAX_LENGTH = 300;

export const DEFAULT_CANCELLATION_POLICY_WINDOW_VALUE = 24;
export const DEFAULT_CANCELLATION_POLICY_WINDOW_UNIT: CancellationPolicyWindowUnit =
  'hours';
export const DEFAULT_CANCELLATION_POLICY_TEXT =
  'Please cancel at least 24 hours before your appointment. Late cancellations may be charged.';
